<template>
  <div class="p_zpxq">
    <p class="zpNav"><span @click="()=>this.$router.push('/')">首页</span> > <span @click="()=>this.$router.back()">首发首创</span> > 详情</p>
    <div class="zpxqHeader">
      <div class="zpmz">
        <h2>首发首创产品/技术</h2>
      </div>
    </div>
    <div class="zpxqContent">
      <div class="contentL">
        <p>
          <span class="p1">首发首创产品/技术名称：</span>
          <span class="p2" style="font-weight: bold;">{{item.first_name}}</span>
        </p>
        <p>
          <span class="p1">展商名称：</span>
          <span class="p2 chaolianjie" >{{item.corpname_cn}}</span>
        </p>
        <p>
          <span class="p1">产品/技术介绍：</span>
          <span class="p2">{{ item.first_introduce }}</span>
        </p>
      </div>
      <my-swiper class="contentR" :urlList="urlList" />
    </div>
  </div>
</template>
<script>
import mySwiper from "./mySwiper.vue";
import { reqNewProductsItem } from "../../../api";
export default {
  components:{
    mySwiper,
  },
  data(){
    return{
      facility:"",
      item: {},
      urlList: []
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
  },
  mounted(){
    // 截取字符串
    let id = this.$route.path.split('/')
    this.id = id[id.length-1]*1
    this.details(this.id)
    // if (!this.isLogin) {
    //   this.$router.push('/home')
    // }
  },
  methods:{
    async details(id=3){
      const res = await reqNewProductsItem(id)
      console.log(res);
      this.item = res.resilt[0]
      if (res.resilt[0].first_img1) {
        this.urlList.push(res.resilt[0].first_img1)
        // this.urlList.push(res.resilt[0].first_img1)
      }
      if (res.resilt[0].first_img2) {
        this.urlList.push(res.resilt[0].first_img2)
      }
      if (res.resilt[0].first_img3) {
        this.urlList.push(res.resilt[0].first_img3)
      }
      console.log(this.urlList);
    }
  }
}
</script>


<style scoped>
.p_zpxq{
  max-width: 1200px;
  margin: 10px auto 0;
  position: relative;
  padding-bottom: 30px;
  
}
.zpNav{
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 600;
  padding-left: 40px;
  width: 256px;
  height: 47px;
  line-height: 47px;
  background-image: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/scNavBg.png");
}
.zpNav span{
  cursor: pointer;
}
.zpNav span:hover{
  color: #008baf;
}
.zpxqHeader{
  background-image: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/scbg.png");
  width: 100%;
  height: 243px;
  padding-top: 60px;
  box-sizing: border-box;
  background-size: 100% 100%;
}
.zsxqHeader::after{
  content: "";
  display: block;
  clear: both;
}
.zpxqImg{
  width: 20px;
}
.zpmz{
  position: absolute;
  left: 70px;
  top: 90px;
  padding-left: 100px;
  background-image: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/sctitleBg.png");
  background-repeat: no-repeat;
  background-position: bottom;
  width: 539px;
  height: 76px;
}
.zpmz h2{
  margin-bottom: 16px;
  color: #fff;
  font-size: 38px;
  font-weight: bold;
  letter-spacing: 4px;
}

.zpxqContent{
  display: flex;
  width: 100%;
  padding: 40px 20px;
}
.zpxqContent::after{
  content: "";
  clear: both;
  display: block;
}
.contentR{
  float: left;
  display: flex;
  margin-right: 20px;
  /* width: 34%; */
  width: 370px;
  height: 310px;
}
.contentL{
  flex: 1;
  padding-top: 50px;
  padding-right: 30px;
  height: auto;
  
}
.contentL >p{
  display: table-row;
  width: 100%;
}
.contentL .p1{
  padding-left: 25px;
  padding-bottom: 15px;
  width: 220px;
  height: 26px;
  display: table-cell;
  font-size: 14px;
  color: #fff;
  line-height: 23px;
  background: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/scnameBg.png") no-repeat;
  background-size: 220px;
}
.contentL .p2{
  padding-left: 10px;
  display: table-cell;
  /* text-indent: 2em; */
  line-height: 24px;
  font-size: 16px;
  width: calc(100% - 92px);
}
.contentL .chaolianjie{
  cursor: pointer;
}
.contentL .chaolianjie:hover{
  color: #008baf;
}

.p_zpxq >>> .el-textarea__inner{
  width: 100%;
  border:1px solid #008baf;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  height: 140px;
}
.el-carousel{
  width: 100%;
}
.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>